import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder fs-4x text-gray-700 mb-10 mt-10 pt-10 text-center" }, "Page Not Found", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3 text-gray-400 mb-15 text-center" }, [
  /*#__PURE__*/_createTextVNode(" The page you looked not found! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Plan your blog post by choosing a topic ")
], -1)
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Go to homepage")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "btn btn-lg btn-primary fw-bolder"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ], 64))
}